var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarSolid16(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-solid-16",
    clipPath: "url(#clip0_2523_1131)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: -0.00598145,
    y: -0.0351562,
    width: 16.006,
    height: 16.035,
    rx: 1.5,
    fill: "#7B868C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2.5C4 2.22386 4.22386 2 4.5 2C4.77614 2 5 2.22386 5 2.5V2.99998L11 2.99999V2.5C11 2.22386 11.2239 2 11.5 2C11.7761 2 12 2.22386 12 2.5V3L13 3C13.5523 3 14 3.44772 14 4V6V7V13.0001C14 13.5524 13.5523 14.0001 13 14.0001H3C2.44772 14.0001 2 13.5524 2 13.0001V7.00003V6.00003V4C2 3.44772 2.44772 2.99997 3 2.99997L4 2.99998V2.5ZM3 7.00003V12.7501C3 12.8881 3.11193 13.0001 3.25 13.0001H12.75C12.8881 13.0001 13 12.8881 13 12.7501V7.00003H3ZM13 6H3V4.25C3 4.11193 3.11193 4 3.25 4H12.75C12.8881 4 13 4.11193 13 4.25V6ZM11.5 10.7501C11.5 11.1643 11.1642 11.5001 10.75 11.5001C10.3358 11.5001 10 11.1643 10 10.7501C10 10.3358 10.3358 10.0001 10.75 10.0001C11.1642 10.0001 11.5 10.3358 11.5 10.7501Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2523_1131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSolid16);
export default __webpack_public_path__ + "static/media/calendar_solid_16.644d1e088cd31b00be4132c32a606bb3.svg";
export { ForwardRef as ReactComponent };